import { render, staticRenderFns } from "./BuyDocumentReport.vue?vue&type=template&id=343fa648&"
import script from "./BuyDocumentReport.vue?vue&type=script&lang=js&"
export * from "./BuyDocumentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports